import { FC } from 'react'

import clsx from 'clsx'
import dayjs from 'dayjs'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

export interface TabBoxProps {
  date?: string
  label: string
  isActive: boolean
  onReset: (e: React.MouseEvent) => void
}

export const TabBox: FC<TabBoxProps> = ({ date, label, isActive, onReset }) => {
  const formatDate = (dateStr?: string) => {
    if (!dateStr) return ''
    const d = dayjs(dateStr.replace(/\//g, '-'))
    return d.format('D MMMM')
  }

  return (
    <div className={clsx(s.box, isActive && s.active)}>
      <div className={s.inputContainer}>
        <span
          className={clsx(
            date ? 'medium-12' : 'medium-16',
            s.subtitle,
            date ? s.subtitleFilled : s.subtitleEmpty,
          )}
        >
          {label}
        </span>
        {date && (
          <span className={clsx('medium-16', s.title)}>{formatDate(date)}</span>
        )}
      </div>
      {date && (
        <button
          className={s.closeButton}
          onClick={onReset}
        >
          <AppIcon
            id={AllIcons.CROSS}
            width={20}
            height={20}
          />
        </button>
      )}
    </div>
  )
}
